'use client';

import { Box, Button, darken, type SxProps } from '@mui/material';
import { useBehaviorSubject } from '@ocodelib/mui/hooks';
import { flatSx, FlexRow } from '@ocodelib/mui';
import type React from 'react';
import { useJsBasicApp } from '../useJsBasicApp';
import { ContentTab } from './ContentTab';

interface Props {
  sx?: SxProps;
  tabNames?: Record<string, string>;
  children?: React.ReactNode;
}

export function ContentTabs(props: Props) {
  const { sx, tabNames = {}, children } = props;
  const { appManager } = useJsBasicApp();
  const contentTabKeys = useBehaviorSubject(appManager.uiState.contentTabs$);
  const currentTabKey = useBehaviorSubject(appManager.uiState.currentContentTab$);

  return (
    <FlexRow
      alignItems="flex-end"
      sx={flatSx(
        {
          pt: 0.5,
          pl: 2,
          height: 40,
          color: 'primary.contrastText',
          bgcolor: 'primary.main',
          '& .ContentTab-root': {
            '& + .ContentTab-root': {
              ml: '2px',
            },
          },
        },
        sx,
      )}
    >
      {contentTabKeys.map((it) => (
        <ContentTab
          key={it}
          title={tabNames[it] ?? it}
          active={it === currentTabKey}
          onClick={() => {
            appManager.uiState.setCurrentContentTab(it);
          }}
        />
      ))}
      <Box sx={{ ml: 2, mb: '4px', color: 'primary.contrastText' }}>
        <Button
          color="inherit"
          variant="outlined"
          size="small"
          onClick={() => {
            document.dispatchEvent(
              new CustomEvent('lecture-dialog-open', {
                detail: {
                  lectureKey: 'lecture.js-basic',
                },
              }),
            );
          }}
        >
          기초학습
        </Button>
      </Box>
      {children}
    </FlexRow>
  );
}
